import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from './environments/environment';

interface RuntimeConfig {
  authServerUrl?: string;
}

// Busca assets/config.json (gerado pelo container via envsubst) e sobrescreve os
// valores compilados em environment.ts. Precisa terminar ANTES de importar
// app.config.ts, já que ele lê environment.authServerUrl na primeira avaliação
// do módulo — por isso os imports abaixo são dinâmicos em vez de estáticos no
// topo do arquivo.
async function loadRuntimeConfig(): Promise<void> {
  try {
    const response = await fetch('/assets/config.json');
    if (!response.ok) return;

    const config: RuntimeConfig = await response.json();
    if (config.authServerUrl) environment.authServerUrl = config.authServerUrl;
  } catch {
    // Sem config.json (ex.: ng serve local) — mantém os valores compilados em environment.ts
  }
}

loadRuntimeConfig()
  .then(() => Promise.all([import('./app/app.config'), import('./app/app')]))
  .then(([{ appConfig }, { App }]) => bootstrapApplication(App, appConfig))
  .catch((err) => console.error('[Bootstrap] Falha ao inicializar:', err));
